// Analista — Prova objetiva (aceitar, conferir folha, lançar notas)

import React from 'react';
import { ExamAnalystTaskQueue } from '../../components/analyst/ExamAnalystTaskQueue';
import { ExamGradeEntryModal } from '../../components/admin/ExamGradeEntryModal';

export const ExamObjectiveAnalysis = React.memo(() => (
  <ExamAnalystTaskQueue
    taskType="objective"
    title="Prova objetiva"
    description="Inscrições atribuídas a você para conferência da folha escaneada e lançamento das notas por área. Aceite a tarefa antes de analisar; após salvar, a situação é atualizada para o administrador."
    processFilter={(p) => p.selection_mode === 'prova' && p.release_grades_manual}
    GradeModal={ExamGradeEntryModal}
  />
));
